import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MailingList from './MailingList.js';
import urls from '../../constants/urls.js';
import logo from '../../images/logo-loudup-grey.png';

const Footer = () => { 
    return (
        <footer className="footer">
            <div className="block-inner">
                <div className="container">
                    <div className="row">                        
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-sm-6">
                                    <ul className="list-unstyled list-footmenu">
                                        <li><Link to="/About" className="transition"><i className="icn icn-arrowrs" />About us</Link></li>
                                        <li><Link to="/FAQ" className="transition"><i className="icn icn-arrowrs" />FAQ</Link></li>
                                        <li><Link to="/Contact" className="transition"><i className="icn icn-arrowrs" />Contact us</Link></li>
                                    </ul>
                                </div>
                                <div className="col-sm-6">
                                    <ul className="list-unstyled list-footmenu">
                                        <li><Link to="/Terms" className="transition"><i className="icn icn-arrowrs" />Terms of use</Link></li>
                                        <li><Link to="/Privacy" className="transition"><i className="icn icn-arrowrs" />Privacy Policy</Link></li>
                                        <li><a href="http://www.mikeapp.co" className="transition"><i className="icn icn-arrowrs" />Band Management</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <MailingList articleType="" />
                        </div>
                        <div className="col-md-4 foot-logo">
                            <img className="logo-foot" src={logo} alt="LoudUp - Discover great new music" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div id="staticboxFooter" className=" staticbox-foot">
                                <p>Get in touch:</p>
                                <a href={urls.FACEBOOK_URL} className="btn-soc btn-fb transition" target="_blank">Facebook</a>
                                <a href={urls.TWITTER_URL} className="btn-soc btn-tw transition" target="_blank">Twitter</a>
                                <a href={urls.YOUTUBE_URL} className="btn-soc btn-yt transition" target="_blank">YouTube</a>
                                <a href={urls.SOUNDCLOUD_URL} className="btn-soc btn-so transition" target="_blank">SoundCloud</a>
                                <a href={urls.PINTEREST_URL} className="btn-soc btn-pi transition" target="_blank">Pinterest</a>
                            </div>
                            <p className="copy">Copyright © {new Date().getFullYear()} LoudUp LTD (registered number: 08079768). All Rights Reserved.</p>
                        </div>
                    </div>
                    <div className="responsive-state" />
                </div>
            </div>
        </footer>
    );
};

export default Footer;
